import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2db9acd8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=2db9acd8&scoped=true&lang=scss&"
import style2 from "./desktop.scss?vue&type=style&index=2&id=2db9acd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9acd8",
  null
  
)

export default component.exports